<template>
	<div class="cetin-data">
		<span v-if="loading || (results && results.products && results.products.length)" class="company-name"> Googli API data: {{ results.priority }} </span>
		<div v-if="loading">
			<tile :loading="loading" :height="'4'" :width="'4'" class="loading-icon"></tile>
		</div>
		<div v-if="results && results.products && results.products.length">
			<div class="cetin-vysledek" style="display: flex; flex-direction: row; flex-wrap: wrap;">
				<div v-for="(item, index) of results.products" class="cetin-vysledek-card" style="display: flex; flex-direction: column; flex-wrap: wrap;" :key="index">
					<div>
						<span>
							id: {{ item.id }}
						</span>
					</div>
					<div>
						<span>
							jméno: {{ item.name }}
						</span>
					</div>
					<div>
						<span>
							rychlost: {{ item.speed }}
						</span>
					</div>
					<div>
						<span>
							cena: {{ item.price }}
						</span>
					</div>
					<div>
						<span>
							instalace: {{ item.installation }}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'GoogliApiResult',

	props: {
		results: { type: Object, default: () => {} },
		loading: { type: Boolean }
	},

	methods: {
  }


}
</script>

<style lang="stylus" scoped>
.cetin-data
    padding-top 10px
    margin-top 15px
    border-bottom 1px solid #4CA5F9
    border-top 1px solid #4CA5F9

.company-name
    font-weight bold
    font-size 24px

.cetin-vysledek
    display flex
    flex-direction column
    border-bottom 1px dashed #4CA5F9
    border-top 1px dashed #4CA5F9

.cetin-vysledek-card
    padding 10px
    background-color white
    border-radius 5px
    margin-right 10px
    margin-bottom 10px

.cetin-vysledek-card-mobile
    padding 10px
    background-color white
    border-radius 5px
    margin-top 5px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important


</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/GoogliApiResult.vue